import { EventEmitter, Inject, Optional, Output } from '@angular/core';
import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogData } from './dialog-data';

@Component({
  selector: 'dialog-modal',
  templateUrl: './dialog.component.html'
})
export class DialogComponent {

  @Output() isConfirmedEvent = new EventEmitter<boolean>();

  public title: string = "";
  public bodyText: string = "";
  public cancelText: string = "";
  public confirmationText: string = "";

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
      public dialogRef: MatDialogRef<DialogComponent>)
  {
    if(data && data.bodyText) {
      this.title = data.title;
      this.bodyText = data.bodyText;
      this.cancelText = data.cancelButtonText;
      this.confirmationText = data.confirmationButtonText;
    }
  }
}
